import {
  ProductBoxes as ProductBoxesComponent,
} from 'b2b-apps/shop/content/components/ModularPage/ModularPage/Modules/ProductBoxListV2/ProductBoxListV2/ProductBoxes/ProductBoxes';
import { withContainer } from './withContainer';

const ProductBoxes = withContainer(ProductBoxesComponent);

export * from './ProductBoxes';
export { ProductBoxes };

